// extracted by mini-css-extract-plugin
export default {"container":"uk4tD7CH","title":"K4FVYs3b","error":"pVJZqZSA","errorCode":"VaYXtYvJ"};